import React, { ReactElement } from 'react'

interface Props {
    needScope: number[];
    userRoles?: number;
    children?: ReactElement | ReactElement[];
}

export const RolElement = ({ needScope, userRoles, children }: Props) => {
    const isAllowed = userRoles && needScope.includes(userRoles);
    return (
        <>
            {
                isAllowed
                    ? children
                    : <></>
            }
        </>
    )
}
